import React from "react";
import ProcessingAnimation from "../../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import LoadingComponent from "../../../../../shared/ui/animations/loading.js";
import Gallery from "../gallery/gallery.js";
import MerchantInfo from "../mainMerchantInfo/merchantInfo.js";
import "./style.css";
export default function Main(props) {
    var _a;
    const { groupData } = props;
    // if (!groupData) return <></>;
    return (React.createElement("main", { className: "gallery-main" },
        props.merchantInfoProps ?
            React.createElement(MerchantInfo, { text: props.merchantInfoProps })
            : null,
        (groupData === null || groupData === void 0 ? void 0 : groupData.type) === "live" && (React.createElement(React.Fragment, null,
            groupData.stage === "added" && (React.createElement("div", { className: "live-group-stage-info" }, "Poczekaj, ta grupa nie zawiera jeszcze \u017Cadnych zdj\u0119\u0107...")),
            groupData.stage === "waiting_for_images" && (React.createElement("div", { className: "live-group-stage-info" }, "Poczekaj, zdj\u0119cia zaraz zostan\u0105 przes\u0142ane...")),
            groupData.stage === "loading_images" && (React.createElement("div", { className: "live-group-stage-info" },
                "Trwa przesy\u0142anie zdj\u0119\u0107...",
                React.createElement("div", { style: { position: "relative", height: "20px", width: "20px" } },
                    React.createElement(ProcessingAnimation, null)))))),
        (props.categories &&
            (((groupData === null || groupData === void 0 ? void 0 : groupData.type) === "live" && (groupData === null || groupData === void 0 ? void 0 : groupData.stage) === "ready") ||
                (groupData === null || groupData === void 0 ? void 0 : groupData.type) !== "live")) ?
            React.createElement(Gallery, { categories: props.categories, type: (_a = groupData === null || groupData === void 0 ? void 0 : groupData.type) !== null && _a !== void 0 ? _a : "default" })
            : React.createElement(LoadingComponent, { color: "classic", extraPadding: true })));
}
